export const getState = state => state.modal;
export const getOpenModals = state => {
    const openModals = {};
    const modals = getState(state);
    for (const name in modals) {
        const modal = modals[name];
        if (modal.open) {
            openModals[name] = modal;
        }
    }
    return openModals;
};
//# sourceMappingURL=selectors.js.map